export default __webpack_public_path__ + "static/serverless-framework-714fba7e4a90325b8ff51cacaa152084.png";